import {Component,OnInit} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {TranslateService} from "@ngx-translate/core";
import {OpeLog,TypeOpeLog} from "@domain/admin/ca/ope-log";
import {SuiviReleveService} from "@components/admin/frais/ndf/suivi-releves/suivi-releve.service";
import {SuiviReleveServiceHttp} from "@services/admin/ca/suivi-releve-service-http.service";
import {Router} from "@angular/router";

/**
 * Composant d'un item de la liste du suivi des relevés
 *
 * @author Guillaume TRAVOT
 * @date 18/03/2026
 */
@Component({
    host: {'data-test-id': 'suivi-releve-list-item'},
    selector: 'suivi-releve-list-item',
    templateUrl: './suivi-releve-list-item.component.html',
    styleUrls: ['./suivi-releve-item.component.scss']
})
export class SuiviReleveListItemComponent extends ListViewItem<OpeLog> implements OnInit {
    /** Libellé du type d'opération */
    typeLibelle: string;

    /** Indique si c'est une réintégration */
    isReintegration: boolean;

    /** Indique s'il y a des erreurs */
    hasErrors: boolean;

    /** Indique si le relevé est déplié */
    _isOuvert: boolean = false;
    get isOuvert(): boolean {
        return this._isOuvert;
    }
    set isOuvert(isOuvert: boolean) {
        this._isOuvert = isOuvert;
        this.suiviReleveService.setReleveFoldedUnfolded(this.data.idRacine, isOuvert);
    }

    /** Liste des logs de l'historique */
    listeHistorique: OpeLog[];

    /**
     * Constructeur
     */
    constructor(
        private translateService: TranslateService,
        private suiviReleveServiceHttp: SuiviReleveServiceHttp,
        private suiviReleveService: SuiviReleveService,
        private router: Router
    ) {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Indique une réintégration
        this.isReintegration = this.data.typeOpeLog === TypeOpeLog.REINTEGRATION;

        //Indique la présence d'erreurs
        this.hasErrors = this.data.nbErreur > 0;

        //Détail du type d'opération
        switch (this.data.typeOpeLog) {
            case TypeOpeLog.IMPORT:
                this.typeLibelle = this.translateService.instant('admin.frais.cartes.suivi.typeImport');
                break;
            case TypeOpeLog.REINTEGRATION:
                this.typeLibelle = this.translateService.instant('admin.frais.cartes.suivi.typeReintegration');
                break;
            default:
                this.typeLibelle = '';
        }

        //Si le relevé est déplié
        if (this.suiviReleveService.isReleveUnfolded(this.data.idRacine)) {
            //Affichage du détail
            this.showHistory();
        }
    }

    /**
     * Affiche l'historique du relevé
     */
    showHistory(): void {
        //Si le relevé est déplié
        if (this.isOuvert) {
            //Bascule du statut à false
            this.isOuvert = false;
        } else {
            //Sinon, bascule du statut à true
            this.isOuvert = true;

            //Si la liste n'existe pas encore
            if (!this.listeHistorique) {
                //Appel pour peupler la liste des détails
                this.suiviReleveServiceHttp.getHistory(this.data.idRacine).subscribe(result => {
                    this.listeHistorique = result?.data?.historyReleve || [];
                });
            }
        }
    }

    /**
     * Ouverture de la liste des erreurs
     * @param event événement d'ouverture
     */
    onOpenErrorList(event: {idLot: number, isLastOpe: boolean}): void {
        this.router.navigate(
            ['Admin/Frais/Ndf/SuiviReleves', event.idLot],
            { queryParams: { isLastOpe: event.isLastOpe } }
        );
    }
}